import { render, staticRenderFns } from "./epidemicRemoval.vue?vue&type=template&id=2788fcae&scoped=true&"
import script from "./epidemicRemoval.vue?vue&type=script&lang=js&"
export * from "./epidemicRemoval.vue?vue&type=script&lang=js&"
import style0 from "./epidemicRemoval.vue?vue&type=style&index=0&id=2788fcae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2788fcae",
  null
  
)

export default component.exports